import { styled, Typography } from '@mui/material';
import { CheckCircle } from '@phosphor-icons/react';

export const InputWrapperStyled = styled('div')({
  maxWidth: '293px',
  marginBottom: '8px'
});

export const CheckCircleStyled = styled(CheckCircle)(({ theme }) => ({
  color: theme.palette.success.main
}));

export const SuccessTextStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.success.main
}));